/**
 * Язык кабинета: русский, английский, латышский (последний — план
 * docs/plans/PLAN_2026-08-13-latvian-language.md).
 *
 * Список закрытый и здесь, и в БД (CHECK миграций 263/266), и на бэкенде
 * (`KNOWN_LANGS`): язык без каталога дал бы кабинет, показывающий ключи вместо
 * слов, поэтому четвёртый приезжает правкой всех трёх мест разом.
 */
export type Lang = 'ru' | 'en' | 'lv'

export const LANGS: readonly Lang[] = ['ru', 'en', 'lv'] as const

/** Плоский каталог: ключ вида `models.drift.emptyReason.noCurrents` → текст. */
export type Catalog = Record<string, string>

/** Подстановки в текст: `{count}`, `{name}`. */
export type Vars = Record<string, string | number>

export function isLang(value: unknown): value is Lang {
  return LANGS.includes(value as Lang)
}

/**
 * Сообщение как ДАННЫЕ: ключ каталога плюс подстановки.
 *
 * Чистая логика кабинета (статус сноса, причина пустоты, готовность слоя) должна
 * решать, ЧТО сказать, но не КАК это звучит: иначе она возвращает готовую фразу,
 * и её тест становится вторым, неявным каталогом переводов — падающим от любой
 * правки формулировки. Поэтому такие функции отдают `Msg`, а слова подставляет
 * компонент через `t(msg.key, msg.vars)`.
 */
export interface Msg {
  key: string
  vars?: Vars
}

export function msg(key: string, vars?: Vars): Msg {
  return vars ? { key, vars } : { key }
}
